import { ApiUtility } from "../Utilities/ApiUtility.axios";


export interface IAMLListItem {
  memberName: string;
  businessName: string;
  provider: string;
  score: number | null;
  date: string | null;
}

export interface IPagedAMLResult<T> {
  totalRecords: number;
  items: T[];
}

class AMLService {
  route = `/Api/AMLReport`;

  getAMLReport = (
    practiceId: number = 0,
    start: number,
    length: any,
    search: string,
    fromDate: string,
    toDate: string,
    sortCol: any,
    sortDir: any,
  ) =>
    ApiUtility.get(`${this.route}`, {
      practiceId,
      start,
      length,
      search,
      fromDate,
      toDate,
      sortDir,
      sortCol,
    });

  getAMLList = (
    practiceId: number,
    start: number = 0,
    length: number = 15,
    sortCol?: string,
    sortDir?: string,
    search: string = "",
    fromDate?: string,
    toDate?: string,
  ) =>
    ApiUtility.get(`${this.route}/aml-report`, {
      practiceId,
      start,
      length,
      sortCol,
      sortDir,
      search,
      fromDate,
      toDate,
    });

  getAMLStatsDownload = (
    practiceId: number,
    practiceName: string,
    search: string = "",
    fromDate?: string,
    toDate?: string,
    sortCol?: string,
    sortDir?: string,
  ) => {
    return ApiUtility.downloadFile(`${this.route}`, {
      practiceId,
      practiceName,
      search,
      fromDate,
      toDate,
      sortCol,
      sortDir,
      isDownload: true,
    });
  };
}
export default new AMLService();